import { useMemo } from "react";
import { useScriptFilenames } from "@/hooks/useApi";
import {
  registeredMiddlewareServices,
  resolvedPipelineScripts,
} from "@/pages/workspaceHelpers";
import type { Connector, ResourceRef } from "@/types/api";

/** The transform scripts a pipeline really has — a registered service and,
 *  once that service's file list is known, a file that exists in it. Shared
 *  by the pipeline and workspace detail pages; `serviceNames` is null until
 *  the services load (everything counts as resolved meanwhile). */
export function usePipelineScripts(
  pipeline: Partial<Connector> | null,
  serviceNames: Set<string> | null,
): ResourceRef[] {
  const scriptServices = useMemo(
    () => registeredMiddlewareServices(pipeline, serviceNames),
    [pipeline, serviceNames],
  );
  const scriptsByService = useScriptFilenames(scriptServices);
  return useMemo(
    () => resolvedPipelineScripts(pipeline, serviceNames, scriptsByService),
    [pipeline, serviceNames, scriptsByService],
  );
}
